export default __webpack_public_path__ + "static/media/1.2a1c7df2.svg";